import React, { useState } from 'react';

// Safety hold banner (2026-10-26): shown at the top of the chat while plan changes are held after reported medical
// red flags. The release is an explicit, recorded attestation with the clearance date — the server validates it
// (on / after the event, not in the future). A chat message never releases the hold.
const KIND_HE = {
  cardiac: 'סימני אזהרה לבביים בזמן מאמץ',
  heat: 'סימנים אפשריים של מכת חום',
  neuro: 'סימנים נוירולוגיים חמורים',
};

const fmt = (iso) => {
  const [y, m, d] = String(iso || '').split('-');
  return y && m && d ? `${Number(d)}.${Number(m)}.${y}` : '';
};

export default function SafetyHoldBanner({ hold, onRelease, today }) {
  const [attest, setAttest] = useState(false);
  const [clearedOn, setClearedOn] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!hold || !hold.active) return null;
  const canSubmit = attest && !!clearedOn && !busy;
  const submit = async () => {
    if (!canSubmit) return;
    setBusy(true);
    setError('');
    try {
      const out = await onRelease({ attest, clearedOn });
      if (!out || !out.ok) setError((out && out.error) || 'לא הצלחתי לשמור את האישור כרגע. נסה שוב בעוד רגע.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mx-4 mt-2 p-4 rounded-xl bg-pressed border border-border" role="alert"
         data-testid="safety-hold-banner" dir="rtl">
      <p className="text-text-body font-bold">⚠️ האימונים מושהים</p>
      <p className="text-text text-sm mt-1" data-testid="safety-hold-text">
        {`ב-${fmt(hold.since)} דיווחת על ${KIND_HE[hold.kind] || 'סימני אזהרה רפואיים'}. `}
        אל תתאמן עד שתיבדק ותקבל אישור רפואי, ושינויים בתכנית מושהים עד אז. אם התסמינים קיימים או חוזרים — פנה
        מיד לעזרה רפואית דחופה (מד״א 101 או חדר מיון).
      </p>
      <label className="flex items-start gap-2 mt-3 text-sm text-text">
        <input type="checkbox" className="mt-1" checked={attest} data-testid="safety-hold-attest"
               onChange={(e) => setAttest(e.target.checked)} />
        <span>נבדקתי על ידי גורם רפואי וקיבלתי אישור לחזור לפעילות.</span>
      </label>
      <label className="block mt-2 text-sm text-text">
        תאריך האישור הרפואי
        <input type="date" className="block mt-1 px-2 py-1 rounded bg-bg border border-border text-text"
               data-testid="safety-hold-date" value={clearedOn} min={hold.since || undefined}
               max={today || undefined} onChange={(e) => setClearedOn(e.target.value)} />
      </label>
      {error && <p className="text-text-body text-sm mt-2" data-testid="safety-hold-error">{error}</p>}
      <button type="button" onClick={submit} disabled={!canSubmit} data-testid="safety-hold-release"
              className="mt-3 w-full h-11 rounded-lg btn-primary">
        {busy ? 'שומר…' : 'קיבלתי אישור רפואי — שחרור'}
      </button>
      <p className="text-text-muted text-xs mt-2">
        התכנית לא תחזור אוטומטית לעומס מלא — אחרי השחרור נתכנן יחד חזרה הדרגתית, וכל שינוי יוצג לאישורך.
      </p>
    </div>
  );
}
